import z from 'zod';

export const CreateMessageTemplateSchema = z
  .object({
    template: z.string().nonempty('required'),
    categoryId: z.number(),
    sortOrder: z.coerce.number().min(1),
    template_clients: z.array(z.number()).optional(),
    allClients: z.boolean().default(false),
  })
  .strict();

export type CreateMessageTemplateRequest = z.infer<
  typeof CreateMessageTemplateSchema
>;

export const UpdateMessageTemplateSchema = z
  .object({
    template: z.string().optional(),
    categoryId: z.number().optional(),
    sortOrder: z.coerce.number().optional(),
    template_clients: z.array(z.number()).optional(),
    allClients: z.boolean().optional(),
    id: z.number().optional(),
  })
  .strict();

// UpdateMessageTemplateDto
export type UpdateMessageTemplateRequest = z.infer<
  typeof UpdateMessageTemplateSchema
>;
